
import React, { useEffect, useMemo, useState } from 'react';


const emptyForm = {
  klijent: '',
  grad: '',
  adresa: '',
  datum_montaze: '',
  dimenzija_ekrana: '',
  model_modula: '',
  raspored_modula: '',
  broj_modula: '',
  serija_modula: '',
  model_modula_2: '',
  model_kartice: '',
  broj_kartica: '',
  kontroler: '',
  server: '',
};

const fields = [
  ['klijent', 'Klijent'],
  ['grad', 'Grad'],
  ['adresa', 'Adresa'],
  ['datum_montaze', 'Datum montaže'],
  ['dimenzija_ekrana', 'Dimenzija ekrana'],
  ['model_modula', 'Model modula'],
  ['raspored_modula', 'Raspored modula'],
  ['broj_modula', 'Broj modula'],
  ['serija_modula', 'Serija modula'],
  ['model_modula_2', 'Model modula 2'],
  ['model_kartice', 'Model kartice'],
  ['broj_kartica', 'Broj kartica'],
  ['kontroler', 'Kontroler'],
  ['server', 'Server'],
];

export default function LEDEkrani() {
  const [screens, setScreens] = useState([]);
  const [sifarnik, setSifarnik] = useState({});
  const [sifarnikError, setSifarnikError] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [sortConfig, setSortConfig] = useState({
    key: '',
    direction: 'asc',
  });
  const [selectedScreen, setSelectedScreen] = useState(null);

  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({ ...emptyForm });
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const loadScreens = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/led-ekrani/', {
        credentials: 'include',
      });

      if (response.status === 401 || response.status === 403) {
        throw new Error('Sesija je istekla. Prijavite se ponovo.');
      }

      if (!response.ok) {
        throw new Error('Greška pri učitavanju LED ekrana.');
      }

      const data = await response.json();
      setScreens(data.screens || []);
    } catch (err) {
      setError(err.message || 'Greška pri učitavanju ekrana.');
    } finally {
      setLoading(false);
    }
  };

  const loadSifarnik = async () => {
    setSifarnikError('');

    try {
      const response = await fetch('/api/led-sifarnik/', {
        credentials: 'include',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        throw new Error('Nije moguće učitati šifarnik.');
      }

      const data = await response.json();
      setSifarnik(data);
    } catch (err) {
      setSifarnikError(err.message || 'Greška pri učitavanju šifarnika.');
    }
  };

  useEffect(() => {
    loadScreens();
    loadSifarnik();
  }, []);

  const handleSort = (key) => {
    setSortConfig((current) => ({
      key,
      direction:
        current.key === key && current.direction === 'asc'
          ? 'desc'
          : 'asc',
    }));
  };

  const filteredScreens = useMemo(() => {
    const query = search.trim().toLocaleLowerCase('sr');
    let result = screens;

    if (query) {
      result = result.filter((screen) =>
        Object.values(screen).some((value) =>
          String(value ?? '').toLocaleLowerCase('sr').includes(query)
        )
      );
    }

    if (sortConfig.key) {
      result = [...result].sort((a, b) => {
        if (sortConfig.key === 'broj_ekrana') {
          const valueA = Number(a.r_br) || 0;
          const valueB = Number(b.r_br) || 0;

          return sortConfig.direction === 'asc'
            ? valueA - valueB
            : valueB - valueA;
        }

        if (sortConfig.key === 'datum_montaze') {
          const parseDate = (value) => {
            const parts = String(value ?? '').split('.');

            if (parts.length >= 3) {
              const day = Number(parts[0]);
              const month = Number(parts[1]);
              const year = Number(parts[2]);

              if (day && month && year) {
                return new Date(year, month - 1, day).getTime();
              }
            }

            return 0;
          };

          const valueA = parseDate(a.datum_montaze);
          const valueB = parseDate(b.datum_montaze);

          return sortConfig.direction === 'asc'
            ? valueA - valueB
            : valueB - valueA;
        }

        const comparison = String(a[sortConfig.key] ?? '').localeCompare(
          String(b[sortConfig.key] ?? ''),
          'sr',
          { sensitivity: 'base' }
        );

        return sortConfig.direction === 'asc'
          ? comparison
          : -comparison;
      });
    }

    return result;
  }, [screens, search, sortConfig]);

  const columns = [
    ['broj_ekrana', 'R.Br.'],
    ['klijent', 'Klijent'],
    ['grad', 'Grad'],
    ['adresa', 'Adresa'],
    ['datum_montaze', 'Datum montaže'],
    ['dimenzija_ekrana', 'Dimenzija ekrana'],
  ];

  const details = [
    ['r_br', 'Redni broj'],
    ...fields,
  ];

  const thStyle = {
    padding: '10px 15px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    backgroundColor: '#162447',
    color: '#7da2ff',
    border: '1px solid #1a2a4a',
    fontSize: '14px',
  };

  const tdStyle = {
    padding: '10px 15px',
    border: '1px solid #1a2a4a',
    color: 'white',
    fontSize: '14px',
    whiteSpace: 'nowrap',
  };

  const primaryButtonStyle = {
    backgroundColor: '#2855d9',
    border: '1px solid #527aff',
    color: 'white',
    borderRadius: '8px',
    padding: '11px 18px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
  };

  const secondaryButtonStyle = {
    backgroundColor: '#162447',
    border: '1px solid #30456e',
    color: 'white',
    borderRadius: '8px',
    padding: '11px 18px',
    fontSize: '14px',
    cursor: 'pointer',
  };

  const inputStyle = {
    width: '100%',
    boxSizing: 'border-box',
    padding: '11px 12px',
    border: '1px solid #30456e',
    borderRadius: '7px',
    backgroundColor: '#101d3b',
    color: 'white',
    fontSize: '14px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    color: '#b7c9ed',
    fontSize: '13px',
    fontWeight: 600,
  };

  const openAddForm = () => {
    setFormData({ ...emptyForm });
    setFormError('');
    setSuccessMessage('');
    setShowAddForm(true);
  };

  const closeAddForm = () => {
    if (saving) return;

    setShowAddForm(false);
    setFormError('');
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormError('');
    setSuccessMessage('');

    if (!formData.klijent.trim()) {
      setFormError('Unesi naziv klijenta.');
      return;
    }

    if (!formData.grad.trim()) {
      setFormError('Unesi grad.');
      return;
    }

    setSaving(true);

    try {
      // Preuzimanje CSRF tokena sa Django servera.
      const csrfResponse = await fetch('/api/led-csrf-token/', {
        method: 'GET',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!csrfResponse.ok) {
        throw new Error(
          csrfResponse.status === 403
            ? 'Server je odbio zahtev za CSRF token. Proveri prijavu i domen.'
            : 'Nije moguće preuzeti CSRF token.'
        );
      }

      const csrfData = await csrfResponse.json();
      const csrfToken = csrfData.csrfToken;

      if (!csrfToken) {
        throw new Error('Server nije vratio CSRF token.');
      }

      const datum = formData.datum_montaze;
      let datumZaUpis = datum;

      // Date input returns YYYY-MM-DD; Google sheet uses DD.MM.YYYY.
      if (/^\d{4}-\d{2}-\d{2}$/.test(datum)) {
        const [godina, mesec, dan] = datum.split('-');
        datumZaUpis = `${dan}.${mesec}.${godina}`;
      }

      const response = await fetch('/api/led-ekrani/dodaj/', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify({ ...formData, datum_montaze: datumZaUpis }),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Sesija je istekla. Prijavi se ponovo.');
        }

        throw new Error(
          result.error ||
            (response.status === 403
              ? 'Server je odbio zahtev. Proveri CSRF zaštitu.'
              : 'Nije uspelo dodavanje ekrana.')
        );
      }

      setShowAddForm(false);
      setFormData({ ...emptyForm });
      setSuccessMessage(`Ekran broj ${result.r_br} je uspešno dodat.`);

      await loadScreens();
    } catch (err) {
      setFormError(err.message || 'Greška pri upisu ekrana.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: '24px', minWidth: 0, color: 'white' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px',
          flexWrap: 'wrap',
          marginBottom: '22px',
        }}
      >
        <div>
          <h1 style={{ margin: 0, fontSize: '26px' }}>LED ekrani</h1>
          <p
            style={{
              margin: '7px 0 0',
              color: '#9eb5e8',
              fontSize: '14px',
            }}
          >
            Evidencija LED ekrana iz Google tabele
          </p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            style={{
              backgroundColor: '#162447',
              color: '#a9c0ff',
              borderRadius: '8px',
              border: '1px solid #1a2a4a',
              padding: '12px 18px',
              fontWeight: 600,
            }}
          >
            {filteredScreens.length} ekrana
          </div>

          <button
            type="button"
            onClick={openAddForm}
            style={primaryButtonStyle}
          >
            + Dodaj LED ekran
          </button>
        </div>
      </div>

      {successMessage && (
        <div
          role="status"
          style={{
            padding: '13px 16px',
            borderRadius: '8px',
            background: '#123b2b',
            color: '#a7f3d0',
            border: '1px solid #24694d',
            marginBottom: '16px',
          }}
        >
          {successMessage}
        </div>
      )}

      <div
        style={{
          backgroundColor: '#0a132b',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid #1a2a4a',
          marginBottom: '16px',
        }}
      >
        <input
          type="search"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Pretraži klijenta, lokaciju, model, kontroler..."
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '12px 14px',
            border: '1px solid #cbd5e1',
            borderRadius: '8px',
            fontSize: '14px',
          }}
        />
      </div>

      {loading && <p>Učitavanje LED ekrana...</p>}

      {!loading && error && (
        <div
          style={{
            padding: '16px',
            background: '#fef2f2',
            color: '#b91c1c',
          }}
        >
          {error}
          <button
            type="button"
            onClick={loadScreens}
            style={{ marginLeft: '12px' }}
          >
            Pokušaj ponovo
          </button>
        </div>
      )}

      {!loading && !error && (
        <div
          style={{
            backgroundColor: '#0a132b',
            border: '1px solid #1a2a4a',
            borderRadius: '8px',
            overflow: 'auto',
            maxHeight: 'calc(100vh - 290px)',
          }}
        >
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
              <tr>
                {columns.map(([key, label]) => {
                  const sortable = [
                    'broj_ekrana',
                    'klijent',
                    'datum_montaze',
                  ].includes(key);

                  const active = sortConfig.key === key;

                  return (
                    <th
                      key={key}
                      onClick={sortable ? () => handleSort(key) : undefined}
                      style={{
                        ...thStyle,
                        ...(sortable
                          ? { cursor: 'pointer', userSelect: 'none' }
                          : {}),
                        ...(key === 'broj_ekrana'
                          ? {
                              width: '55px',
                              minWidth: '55px',
                              padding: '8px 6px',
                              textAlign: 'center',
                            }
                          : {}),
                      }}
                    >
                      {label}
                      {sortable && (
                        <span style={{ marginLeft: '6px' }}>
                          {active
                            ? sortConfig.direction === 'asc'
                              ? '▲'
                              : '▼'
                            : '↕'}
                        </span>
                      )}
                    </th>
                  );
                })}
              </tr>
            </thead>

            <tbody>
              {filteredScreens.map((screen, index) => (
                <tr
                  key={`${screen.r_br}-${index}`}
                  onClick={() => setSelectedScreen(screen)}
                  title="Klikni za detalje ekrana"
                  style={{ cursor: 'pointer' }}
                  onMouseEnter={(event) => {
                    event.currentTarget.style.backgroundColor = '#162447';
                  }}
                  onMouseLeave={(event) => {
                    event.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  {columns.map(([key]) => (
                    <td
                      key={key}
                      style={{
                        ...tdStyle,
                        ...(key === 'broj_ekrana'
                          ? {
                              textAlign: 'center',
                              padding: '8px 6px',
                            }
                          : {}),
                      }}
                    >
                      {key === 'broj_ekrana'
                        ? screen.r_br || index + 1
                        : screen[key] || '—'}
                    </td>
                  ))}
                </tr>
              ))}

              {filteredScreens.length === 0 && (
                <tr>
                  <td
                    colSpan={columns.length}
                    style={{
                      padding: '30px',
                      textAlign: 'center',
                      color: '#9eb5e8',
                    }}
                  >
                    Nema pronađenih ekrana.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {selectedScreen && (
        <div
          onClick={() => setSelectedScreen(null)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: '100%',
              maxWidth: '700px',
              maxHeight: '85vh',
              overflowY: 'auto',
              backgroundColor: '#0a132b',
              border: '1px solid #3366ff',
              borderRadius: '10px',
              padding: '24px',
              boxSizing: 'border-box',
              color: 'white',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px',
                marginBottom: '22px',
              }}
            >
              <div>
                <h2 style={{ margin: 0, fontSize: '23px' }}>
                  {selectedScreen.klijent || 'LED ekran'}
                </h2>
                <p
                  style={{
                    margin: '6px 0 0',
                    color: '#9eb5e8',
                    fontSize: '14px',
                  }}
                >
                  {selectedScreen.grad || 'Lokacija nije navedena'}
                </p>
              </div>

              <button
                type="button"
                onClick={() => setSelectedScreen(null)}
                style={secondaryButtonStyle}
              >
                ×
              </button>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                gap: '12px',
              }}
            >
              {details.map(([key, label]) => (
                <div
                  key={key}
                  style={{
                    backgroundColor: '#101d3b',
                    border: '1px solid #1a2a4a',
                    borderRadius: '8px',
                    padding: '13px 15px',
                  }}
                >
                  <div
                    style={{
                      color: '#9eb5e8',
                      fontSize: '12px',
                      marginBottom: '6px',
                    }}
                  >
                    {label}
                  </div>

                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 600,
                      overflowWrap: 'anywhere',
                    }}
                  >
                    {selectedScreen[key] !== null &&
                    selectedScreen[key] !== undefined &&
                    String(selectedScreen[key]).trim() !== ''
                      ? selectedScreen[key]
                      : '—'}
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '22px',
              }}
            >
              <button
                type="button"
                onClick={() => setSelectedScreen(null)}
                style={secondaryButtonStyle}
              >
                Zatvori
              </button>
            </div>
          </div>
        </div>
      )}

      {showAddForm && (
        <div
          onClick={closeAddForm}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1100,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: '100%',
              maxWidth: '850px',
              maxHeight: '90vh',
              overflowY: 'auto',
              backgroundColor: '#0a132b',
              border: '1px solid #3366ff',
              borderRadius: '12px',
              padding: '24px',
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '22px',
                paddingBottom: '16px',
                borderBottom: '1px solid #1a2a4a',
              }}
            >
              <div>
                <h2 style={{ margin: 0, fontSize: '23px' }}>
                  Dodaj LED ekran
                </h2>
                <p
                  style={{
                    margin: '6px 0 0',
                    color: '#9eb5e8',
                    fontSize: '13px',
                  }}
                >
                  Redni broj se dodeljuje automatski.
                </p>
              </div>

              <button
                type="button"
                onClick={closeAddForm}
                disabled={saving}
                style={secondaryButtonStyle}
              >
                ×
              </button>
            </div>

            {sifarnikError && (
              <div
                role="status"
                style={{
                  marginBottom: '14px',
                  padding: '10px 12px',
                  borderRadius: '7px',
                  backgroundColor: '#451b24',
                  border: '1px solid #8c3545',
                  color: '#fecaca',
                  fontSize: '13px',
                }}
              >
                {sifarnikError} Unos je i dalje moguć ručno.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                  gap: '16px',
                }}
              >
                {fields.map(([name, label]) => (
                  <label
                    key={name}
                    style={{ display: 'block', minWidth: 0 }}
                  >
                    <span style={labelStyle}>
                      {label}
                      {(name === 'klijent' || name === 'grad') && (
                        <span style={{ color: '#ff8585' }}> *</span>
                      )}
                    </span>

                    <input
                      type={name === 'datum_montaze' ? 'date' : 'text'}
                      name={name}
                      value={formData[name]}
                      onChange={handleFormChange}
                      list={
                        {
                          klijent: 'led-klijenti',
                          model_modula: 'led-modeli-modula',
                          model_modula_2: 'led-oznake-modula',
                          serija_modula: 'led-serije-modula',
                          model_kartice: 'led-modeli-kartica',
                          kontroler: 'led-kontroleri',
                          server: 'led-serveri',
                        }[name] || undefined
                      }
                      placeholder={
                        name === 'datum_montaze'
                          ? undefined
                          : `Unesi: ${label.toLocaleLowerCase('sr')}`
                      }
                      required={name === 'klijent' || name === 'grad'}
                      disabled={saving}
                      style={inputStyle}
                    />
                    {{
                      klijent: 'klijenti',
                      model_modula: 'modeli_modula',
                      model_modula_2: 'oznake_modula',
                      serija_modula: 'serije_modula',
                      model_kartice: 'modeli_kartica',
                      kontroler: 'kontroleri',
                      server: 'serveri',
                    }[name] && (
                      <datalist
                        id={
                          {
                            klijent: 'led-klijenti',
                            model_modula: 'led-modeli-modula',
                            model_modula_2: 'led-oznake-modula',
                            serija_modula: 'led-serije-modula',
                            model_kartice: 'led-modeli-kartica',
                            kontroler: 'led-kontroleri',
                            server: 'led-serveri',
                          }[name]
                        }
                      >
                        {(sifarnik[
                          {
                            klijent: 'klijenti',
                            model_modula: 'modeli_modula',
                            model_modula_2: 'oznake_modula',
                            serija_modula: 'serije_modula',
                            model_kartice: 'modeli_kartica',
                            kontroler: 'kontroleri',
                            server: 'serveri',
                          }[name]
                        ] || []).map((option) => (
                          <option key={option} value={option} />
                        ))}
                      </datalist>
                    )}
                  </label>
                ))}
              </div>

              {formError && (
                <div
                  role="alert"
                  style={{
                    marginTop: '18px',
                    padding: '12px 14px',
                    borderRadius: '8px',
                    backgroundColor: '#451b24',
                    border: '1px solid #8c3545',
                    color: '#fecaca',
                    fontSize: '14px',
                  }}
                >
                  {formError}
                </div>
              )}

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                  flexWrap: 'wrap',
                  marginTop: '24px',
                  paddingTop: '18px',
                  borderTop: '1px solid #1a2a4a',
                }}
              >
                <button
                  type="button"
                  onClick={closeAddForm}
                  disabled={saving}
                  style={secondaryButtonStyle}
                >
                  Otkaži
                </button>

                <button
                  type="submit"
                  disabled={saving}
                  style={{
                    ...primaryButtonStyle,
                    opacity: saving ? 0.65 : 1,
                  }}
                >
                  {saving ? 'Upisivanje...' : 'Sačuvaj ekran'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}